import React, { Component } from 'react';
import InputFieldComponent from './InputFieldComponent';

class TextInputFieldComponent extends Component {
    render() {
        return <InputFieldComponent {...this.props} type="text" />;
    }
}

// See proptypes in ./InputFieldComponent.js

export default TextInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/TextInputFieldComponent.js